<div class="flex flex-col gap-4" [class]="direction">
  <!--
    a11y: top close button — first in DOM, focusInitial=true so initial
    focus lands here on open. Rendered on mobile too (audit requires every
    popup to expose a top close button as the initial focus target).
  -->
  <div class="!flex justify-end">
    <mot-button matType="icon" icon="close"
      [ariaLabel]="closeText"
      class="!border-none !w-min !h-min cursor-pointer !bg-transparent" iconClass="!text-2xl"
      [focusInitial]="true"
      (onClick)="closeCard()" />
  </div>

  @if (!isLoading) {
    <div class="w-full flex flex-col gap-2 items-center justify-center p-4">
      <p class="m-0 text-center">{{lineNotActiveText}}</p>
      @if (getNextDayOfServiceText()) {
        <p class="m-0 text-center">{{getNextDayOfServiceText()}}</p>
      }
    </div>
  }

  @if (isDesktop) {
    <div class="!flex justify-end !sticky bottom-2 px-2">
      <mot-button [text]="closeText"
        buttonClass="!bg-primary !w-4 !text-white !px-2 !py-3 !rounded-lg !align-middle mt-0.5"
        (onClick)="closeCard()" />
      </div>
    }
  </div>
